const NotFound = () => {
    return (
        <div className="flex items-center justify-center p-4 min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            <div className="bg-white w-full max-w-4xl rounded-lg shadow-xl overflow-hidden">
                {/* Header */}
                <div className="bg-gray-800 text-white px-8 py-6 flex items-center justify-between">
                    <div className="flex items-center">
                        <div className="w-14 h-14 bg-blue-500 rounded-lg flex items-center justify-center mr-4">
                            <i className="fas fa-exclamation-triangle text-white text-2xl"></i>
                        </div>
                        <h1 className="text-3xl font-bold">DDtank <span className="text-blue-300">Erro 404</span></h1>
                    </div>
                </div>

                {/* Content */}
                <div className="p-8">
                    <div className="mb-8 border-b border-gray-200 pb-6">
                        <div className="flex items-center mb-4">
                            <div className="bg-red-100 text-red-500 p-2 rounded-full mr-3">
                                <i className="fas fa-exclamation-circle"></i>
                            </div>
                            <span className="text-sm text-gray-500">Página não encontrada</span>
                        </div>

                        <h2 className="text-3xl font-bold text-gray-800 mb-4">Oops! Algo deu errado</h2>

                        <div className="text-gray-700 mb-8">
                            <p>A página que você está tentando acessar não existe ou foi movida.</p>
                            <p className="mt-4">Verifique o endereço digitado ou volte para a página inicial.</p>
                        </div>
                    </div>

                    {/* Back Button */}
                    <div className="text-center">
                        <a
                            href="/"
                            className="inline-flex items-center px-6 py-3 text-white font-medium rounded-lg bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg"
                        >
                            <i className="fas fa-arrow-left mr-2"></i>
                            Voltar para a página inicial
                        </a>
                    </div>
                </div>

                {/* Footer */}
                <div className="bg-gray-800 text-white px-6 py-4 text-center text-sm">
                    <p>DDtank Splush © {new Date().getFullYear()} - Todos os direitos reservados</p>
                    <div className="flex justify-center space-x-4 mt-2">
                        <a href="#" className="hover:text-blue-300"><i className="fab fa-facebook"></i></a>
                        <a href="#" className="hover:text-blue-400"><i className="fab fa-twitter"></i></a>
                        <a href="#" className="hover:text-red-400"><i className="fab fa-youtube"></i></a>
                        <a href="#" className="hover:text-purple-400"><i className="fab fa-discord"></i></a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;